import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListItems, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetMonthlySalaryDeduction, doSaveMonthlySalaryDeduction, doRelease } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import MonthlySalaryDeductionInfoDiv from './MonthlySalaryDeductionInfoDiv'
import ObjectionDeductionDiv from './ObjectionDeductionDiv'

class MonthlySalaryDeductionDetail extends React.Component {
    state = {
        changedValues基本信息: {},
        bSave: false
    }

    componentDidMount = () => {
        this.doGetMonthlySalaryDeduction(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }

    doGetMonthlySalaryDeduction = (id) => {
        const { dispatch, taskName } = this.props
        dispatch(doGetMonthlySalaryDeduction({
            id: id || 0,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ bSave: false })
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose, id } = this.props
        const { changedValues基本信息, bSave } = this.state
        const { list: list加扣项明细 } = Tyan.utility.getListItems(this, '基本信息', '加扣项明细')
        if (!bSave) {
            this.setState({ bSave: true })
            dispatch(doSaveMonthlySalaryDeduction({
                id,
                list加扣项明细,
                changedValues基本信息,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        this.setState({ bSave: false })
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('保存成功')
                        this.doGetMonthlySalaryDeduction(id)
                    }
                }
            }))
        }
    }

    handlerRelease = () => {
        const { dispatch, onClose, onSave, id } = this.props
        const { bSave } = this.state
        if (!bSave) {
            this.setState({ bSave: true })
            dispatch(doRelease({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        this.setState({ bSave: false })
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('发布成功')
                        this.doGetMonthlySalaryDeduction(id)
                    }
                }
            }))
        }
    }

    handelSubmit = (action, title) => {
        const { onSave, onClose, dispatch, showDetail } = this.props
        const { id } = this.state
        doMonthlySalaryDeductionAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const 薪资给付日 = getFormValue(this, '基本信息', '薪资给付日')
        return Object.keys(changedValues基本信息).length > 0 && 薪资给付日 && 薪资给付日 !== nullDate
    }

    handelExportDeduction = () => {
        const { id } = this.props
        Tyan.pubForm.showExport({ event: 'ExportDeduction', eventData: { id }, title: '导出加扣项明细' })
    }

    handleShowDiv = (id, personID, salaryApplyID) => {
        Tyan.pubForm.showDialog('加扣项', props => <MonthlySalaryDeductionInfoDiv {...props} id={id} personID={personID} salaryApplyID={salaryApplyID} onRefresh={() => this.doGetMonthlySalaryDeduction(salaryApplyID)} />)
    }

    fieldset月薪记录 = () => {
        const { id: salaryApplyID } = this.state
        const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
        const { list: 人员加扣项 } = Tyan.utility.getListItems(this, '基本信息', '人员加扣项')
        return [
            {
                _group: '', minWidth: '95%', items: [
                    { _text: '发放月份', name: '薪资期号', minWidth: '250', disabled: true },
                    { _date: '薪资给付日', minWidth: '300', required: true, align: 'left' },
                    { _label: '', flex: 60 }
                ]
            },
        ].concat(人员加扣项.map(o => {
            return {
                _grid: `${o.title}`, name: `人员加扣项[${o.id}].加扣项明细`, minWidth: '40%', rowNumbers: true, minRows: 5, /*maxRows: 11,  height: '100%', */
                columns: [
                    { _text: '科目名称', flex: 4 },
                    { _float: '金额', flex: 2, renderer: (that, { data }) => <span style={{ 'color': data.状态 == '登记中' && data.最新发布时间 !== nullDate ? 'red' : 'black', }} > {data.金额} </span>, },
                    { _text: '状态', flex: 2 },
                    { _text: '备注', flex: 6 },
                ],
                buttons: [
                    { _button: '设置...', icon: 'plus', handler: () => this.handleShowDiv(0, o.id, salaryApplyID), }
                ],
                onDoubleTap: data => { Tyan.pubForm.showDialog('加扣项', props => <ObjectionDeductionDiv {...props} id={data.id} onFlowFinished={() => this.doGetMonthlySalaryDeduction(salaryApplyID)} />) },
            }
        }))
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, bUpdate, bRelease } = initValues基本信息
        return <Body data={this}
            controls={
                [
                    { _button: '导出', icon: 'save', handler: () => this.handelExportDeduction(),/*  cdt: () => 状态 == 3, */ },
                    {
                        _button: '上传', icon: 'share', handler: () =>
                            Tyan.pubForm.showImport(
                                'ImportSalaryInfo'/*event name*/,
                                '上传加扣项明细'/*对话框标题*/,
                                (data) => this.doGetMonthlySalaryDeduction(id),
                                '.xls,.xlsx',
                                { id })
                        , cdt: () => 状态 == 1 && bUpdate, disabled: this.bChanged()
                    },
                    { _button: '发布', icon: 'share', handler: () => this.handlerRelease(), cdt: () => 状态 == 1 && bRelease, disabled: this.bChanged() },
                    { _button: '保存', icon: 'save', handler: () => this.handlerSave(), cdt: () => 状态 == 1, disabled: !this.bSave() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '薪资加扣项', name: '基本信息', _fieldset: this.fieldset月薪记录(), minWidth: '1500', forceDisabled: 状态 !== 1 },
                ]
            }
        />
    }
}

export default connect()(MonthlySalaryDeductionDetail)